module.exports = __webpack_public_path__ + "img/17_96.0ac7f158.png";